// extracted by mini-css-extract-plugin
module.exports = {"value-input":"ValueInput_value-input__3yp2z"};